import React, { useMemo, useState } from 'react';
import CardCommon from '@op/components/CardCommon';
import {
  barIcon,
  lineIcon,
  pieIcon,
  stackLineIcon,
  tableIcon,
} from '@op/constants/chart';
import Chart from './Chart';
import { useVoiceReportingTextAnalysisTimeline } from '../../hooks/useVoiceReport';
import { downloadAction } from '@op/pages/download/utils';
import { IIntentOptions, transIntent } from '..';
import { getLocale, useIntl } from 'umi';
interface IIntentDistributionTrend {
  gameInfo: any;
  filter: any;
  intentOptions: IIntentOptions[];
}
export default function IntentDistributionTrend(props: IIntentDistributionTrend) {
  const { filter, intentOptions } = props;
  const [type, setType] = useState('bar');
  const height = 320;
  const locale = getLocale();
  const { formatMessage } = useIntl();

  const { data, loading } = useVoiceReportingTextAnalysisTimeline({
    filter,
  });

  const columnsConfig = useMemo(() => {
    const { tableRecord } = data || {};
    const columns: any[] = [];

    if (tableRecord?.length > 0) {
      const allKeys = new Set<string>();

      tableRecord.forEach((item: any) => {
        Object.keys(item || {})
          .filter(key => key !== 'time')
          .forEach(key => allKeys.add(key));
      });

      allKeys.forEach((key) => {
        columns.push({
          name: key === 'total' ? 'Total Intent' : transIntent(intentOptions, key),
          key,
          valueFormat: (value: any) => value,
        });
      });
    }

    return columns;
  }, [data, intentOptions, locale]);

  const formattedData = useMemo(() => {
    let { pieData, legend, series } = data || {};

    pieData = pieData?.map((item: any) => ({
      ...item,
      name: transIntent(intentOptions, item.name),
      key: transIntent(intentOptions, item.key),
    }));

    legend = legend?.map((item: any) => transIntent(intentOptions, item));

    series = series?.map((item: any) => ({
      ...item,
      name: transIntent(intentOptions, item.name),
    }));

    return {
      ...data,
      pieData,
      legend,
      series,
    };
  }, [data, intentOptions, locale]);

  return (
    <CardCommon
      title={formatMessage({ id: 'Intent Distribution Trend' })}
      className="dbo-intent-distribution-card"
      hasDownload={data?.tableRecord}
      operationInfo={[type, setType]}
      operations={[barIcon, lineIcon, stackLineIcon, pieIcon, tableIcon]}
      loading={loading}
      loadingHeight={height}
      empty={data?.isEmpty}
      emptyHeight={height}
      handleDownloadOnClick={() => {
        downloadAction({
          key: 'VoiceReportingTextAnalysisChart',
          fileName: 'Voice Reporting Text Analysis',
          filter,
          auxiliaryParams: {
            dateType: filter?.date_type || 'daily',
            columnsConfig,
          },
          data: data?.tableRecord || [],
        });
      }}
      logBtnId={'IntentDistributionTrend'}
    >
      <Chart
        type={type}
        data={formattedData}
        columnsConfig={columnsConfig}
        sumLabel={'Total Intent'}
        tooltipRightTitle={'The number of reports'}
        height={height}
        {...props}
      />
    </CardCommon>
  );
}
